import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const BirdOfThunder = () => (
  <StaticQuery
    query=
      {graphql`
        query {
          bg: file(relativePath: { eq: "games/bird-of-thunder.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 1200) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
    render={data => (
      <div className="game-banner">
        {data.bg.childImageSharp.fluid &&
          <Img alt="Bird Of Thunder" fluid={data.bg.childImageSharp.fluid}/>
        }
      </div>
    )}
  />
);

export default BirdOfThunder;